define([
    "views/open_account/demo_account_view"
], function(DemoAccountView) {
    return DemoAccountView;
});


//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/views/w/competition/application_view.js
// module id = 24
// module chunks = 0